import { render, staticRenderFns } from "./FreeTipDialog.vue?vue&type=template&id=0e8f1af9&scoped=true&"
import script from "./FreeTipDialog.vue?vue&type=script&lang=js&"
export * from "./FreeTipDialog.vue?vue&type=script&lang=js&"
import style0 from "./FreeTipDialog.vue?vue&type=style&index=0&id=0e8f1af9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8f1af9",
  null
  
)

export default component.exports